/* @flow */
import * as React from 'react';
import ConfirmDialog from 'components/ConfirmDialog.jsx';
import DeviceActions from 'actions/DeviceActions';
import EventTracking from 'lib/EventTracking';
import errorLogger from 'utils/errorLogger';

type Props = {
  message: string,
  oldUserEmail: string,
  eventScreenName: string,
  onDone: Function,
  onRequestHide: Function,
};

class EmailMergeConfirmDialog extends React.Component<Props> {
  sendRequest = () => {
    EventTracking.tap(this.props.eventScreenName, 'EmailMergeConfirmDialogYesButton');
    DeviceActions.createEmailMergeRequest(this.props.oldUserEmail)
      .then(() => {
        this.props.onDone();
      })
      .catch(errorLogger('EmailMergeConfirmDialog sendRequest failed'));
  };

  render() {
    return (
      <ConfirmDialog
        eventScreenName="EmailMergeConfirmDialog"
        title={this.props.message}
        subtext={'Would you like to merge these accounts?'}
        actionButtonText="Yes"
        cancelButtonText="No"
        onRequestHide={this.props.onRequestHide}
        onConfirm={this.sendRequest}
        staticModal={false}
      />
    );
  }
}

export default EmailMergeConfirmDialog;
